/**
 * Input Schema of WebserviceIntegracao
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {WebserviceIntegracao} from '@/model/resource/WebserviceIntegracao'

/* TODO: review generated schema */
export class InputWebserviceIntegracaoSchema extends Schema {
  readonly name = 'InputWebserviceIntegracao'

  readonly fieldSet: FieldSet<WebserviceIntegracao> = {
    path: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 127,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
